import { environment as config } from "../../../environments/environment";

const { domain, clientId, audience, apiUri, errorPath } = config.auth0 as {
  domain: string;
  clientId: string;
  audience?: string;
  apiUri: string;
  errorPath: string;
};

export const environment = {
  production: config.production,
  auth: {
    domain,
    clientId,
    ...(audience && audience !== "" ? { audience } : null),
    redirectUri: window.location.origin,
    errorPath,
  },
  // httpInterceptor: {
  //   allowedList: [`${apiUri}/*`],
  // },
};
